module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/reward-tiers/hat-770b88d585abc135b9cc52648b42a05b.svg";